import { NetCDFReader } from 'netcdfjs';
import { advionGCMS } from "./advionGCMS.js";
import { agilentGCMS } from "./agilentGCMS.js";
import { agilentHPLC } from "./agilentHPLC.js";
import { aiaTemplate } from "./aiaTemplate.js";
import { brukerGCMS } from "./brukerGCMS.js";
import { finniganGCMS } from "./finniganGCMS.js";
import { shimadzuGCMS } from "./shimadzuGCMS.js";
/**
 * Reads a NetCDF file and returns a formatted JSON with the data from it.
 * @param data - ArrayBuffer or any Typed Array (including Node.js' Buffer from v4) with the data
 * @returns JSON with the time, TIC and mass spectra values
 */
export function netcdfGcms(data) {
    const reader = new NetCDFReader(data);
    const globalAttributes = reader.globalAttributes;
    const instrumentMfr = reader.dataVariableExists('instrument_mfr') &&
        reader.getDataVariableAsString('instrument_mfr');
    const datasetOrigin = reader.attributeExists('dataset_origin');
    const massValues = reader.dataVariableExists('mass_values');
    const detectorName = reader.getAttribute('detector_name');
    const aiaTemplateRevision = reader.attributeExists('aia_template_revision');
    const sourceFileFormat = reader.getAttribute('source_file_format');
    let result;
    if (massValues && datasetOrigin) {
        result = agilentGCMS(reader);
    }
    else if (massValues && instrumentMfr && instrumentMfr.match(/finnigan/i)) {
        result = finniganGCMS(reader);
    }
    else if (massValues && instrumentMfr && instrumentMfr.match(/bruker/i)) {
        result = brukerGCMS(reader);
    }
    else if (massValues &&
        sourceFileFormat &&
        String(sourceFileFormat).match(/shimadzu/i)) {
        result = shimadzuGCMS(reader);
    }
    else if (massValues &&
        sourceFileFormat &&
        String(sourceFileFormat).match(/advion/i)) {
        result = advionGCMS(reader);
    }
    else if (detectorName && String(detectorName).match(/(?:dad|tic)/i)) {
        result = agilentHPLC(reader);
    }
    else if (aiaTemplateRevision) {
        result = aiaTemplate(reader);
    }
    else {
        throw new TypeError('Unknown file format');
    }
    return {
        ...result,
        meta: addMeta(globalAttributes),
        variables: addVariables(reader),
    };
}
/**
 * Reads a NetCDF file with Agilent GCMS format and returns a formatted JSON with the data from it.
 * @param data - ArrayBuffer or any Typed Array (including Node.js' Buffer from v4) with the data
 * @returns JSON with the time, TIC and mass spectra values
 */
export function fromAgilentGCMS(data) {
    return agilentGCMS(new NetCDFReader(data));
}
/**
 * Reads a NetCDF file with Agilent HPLC format and returns a formatted JSON with the data from it.
 * @param data - ArrayBuffer or any Typed Array (including Node.js' Buffer from v4) with the data
 * @returns JSON with the time, TIC and mass spectra values
 */
export function fromAgilentHPLC(data) {
    return agilentHPLC(new NetCDFReader(data));
}
/**
 * Reads a NetCDF file with Finnigan format and returns a formatted JSON with the data from it.
 * @param data - ArrayBuffer or any Typed Array (including Node.js' Buffer from v4) with the data
 * @returns JSON with the time, TIC and mass spectra values
 */
export function fromFinniganGCMS(data) {
    return finniganGCMS(new NetCDFReader(data));
}
/**
 * Reads a NetCDF file with AIA template format and returns a formatted JSON with the data from it.
 * @param data - ArrayBuffer or any Typed Array (including Node.js' Buffer from v4) with the data
 * @returns JSON with the time, TIC and mass spectra values
 */
export function fromAiaTemplate(data) {
    return aiaTemplate(new NetCDFReader(data));
}
function addMeta(globalAttributes) {
    const meta = {};
    for (const item of globalAttributes) {
        meta[item.name] = item.value;
    }
    return meta;
}
function addVariables(reader) {
    return reader.variables.map((variable) => ({
        ...variable,
        value: reader.getDataVariable(variable),
    }));
}
//# sourceMappingURL=index.js.map